{
  "$schema": "./gameplay.schema.json",
  "camera": {
    "landscape": { "fov": 40, "height": 165, "behind": 9, "lookAhead": 50 },
    "portrait": { "fov": 58, "height": 150, "behind": 16, "lookAhead": 30 },
    "follow": { "riverShare": 0.6, "riverAhead": 60, "jetShare": 0.4, "damping": 1.1 },
    "breathe": { "amp": 3, "rate": 0.23 }
  },
  "render": {
    "exposure": 0.92,
    "shadowMapMin": 2048,
    "shadowHalfExtent": 150,
    "fog": { "near": 280, "far": 1300 },
    "dpr": { "fixedUpTo": 2, "adaptiveMin": 1.5, "adaptiveMax": 2 }
  },
  "flight": {
    "cruise": 44,
    "min": 26,
    "max": 62,
    "steerResponse": 2.4,
    "bankMax": 0.85,
    "lateralSpeed": 30,
    "sensitivity": { "min": 0.5, "max": 1.5 },
    "throttleEase": 3,
    "altitude": 12
  },
  "guns": {
    "interval": 0.09,
    "tracerSpeedBonus": 300,
    "tracerLife": 0.9,
    "bridgeHitsBase": 6,
    "bridgeHitsPerLevel": 1
  },
  "fuel": { "drainPerSec": 0.028, "refuelPerSec": 0.75, "lowThreshold": 0.3 },
  "crash": {
    "bankHeight": 1.4,
    "jetBox": { "halfWidth": 3.6, "halfLength": 5 },
    "bridgeDz": 7,
    "tracerZone": { "across": 3.2, "along": 4.5 },
    "flakRadius": 5
  },
  "lives": {
    "start": 3,
    "extraEvery": 10000,
    "max": 5,
    "wreckSec": 2.8,
    "invulnSec": 2.6,
    "checkpointPastBridge": 150,
    "gameOverSec": 3.6
  },
  "score": { "gunboat": 30, "heli": 60, "fuel": 80, "jet": 100, "bridge": 500 },
  "enemies": {
    "hitBox": {
      "gunboat": { "halfWidth": 8.2, "halfLength": 3.2 },
      "heli": { "halfWidth": 6.2, "halfLength": 6.2 },
      "jet": { "halfWidth": 6.6, "halfLength": 6.2 },
      "fuel": { "halfWidth": 5.8, "halfLength": 11.5 }
    },
    "heliAltitude": { "min": 13, "max": 17 },
    "jetAltitude": 14,
    "patrolSpeed": {
      "gunboat": { "base": 4, "perLevel": 1.1 },
      "heli": { "base": 7, "perLevel": 1.5 },
      "jet": { "base": 60, "perLevel": 3 }
    },
    "bankClearance": { "gunboatExtra": 3, "heli": 5 },
    "sleeperRange": 250,
    "sleeperShare": 0.5,
    "jetAhead": { "min": 85, "max": 140 },
    "jetExitBeyond": 115
  },
  "firing": {
    "heli": { "range": { "min": 35, "max": 170 }, "side": 80, "speed": 120, "spread": 2.5 },
    "gunboat": { "range": { "min": 35, "max": 210 }, "side": 80, "speed": 85, "spread": 4 },
    "bridgeGun": { "range": { "min": 40, "max": 250 }, "speed": 120, "spread": 4 },
    "cooldown": { "base": 2.4, "perLevel": 0.18, "min": 0.55, "jitter": 0.8 },
    "bridgeCooldown": { "base": 0.45, "distanceDivisor": 240, "jitter": 0.35 },
    "quietAfterRespawnSec": 2.6
  },
  "spawning": {
    "sectionLength": 800,
    "startPastBridge": 150,
    "minSpacing": 34,
    "islandClear": 75,
    "margin": { "gunboat": 12, "fuel": 12, "heli": 6 }
  },
  "difficulty": {
    "gunboats": { "base": 3, "perLevel": 0.8, "max": 10 },
    "helis": { "base": 2, "perLevel": 0.9, "max": 10 },
    "fuel": { "base": 4, "levelDivisor": 3, "min": 2 },
    "jets": { "fromLevel": 3, "base": 1, "levelDivisor": 2, "max": 4 },
    "heliPatrol": { "fromLevel": 2, "base": 0.3, "perLevel": 0.08 },
    "gunboatPatrol": { "fromLevel": 3, "base": 0.2, "perLevel": 0.08 },
    "heliFire": { "fromLevel": 4, "base": 0.4, "perLevelAbove": 0.08 },
    "gunboatFlak": { "fromLevel": 5, "base": 0.35, "perLevelAbove": 0.08 },
    "bridgeGunsFromLevel": 3
  },
  "banners": { "normalSec": 2.2, "dangerSec": 2.8, "gameOverSec": 3.6, "gapSec": 0.35 },
  "flow": { "titleFadeSec": 4.5 },
  "text": {
    "levelPrefix": "LEVEL",
    "levelBanners": [
      "CLEAR THE RIVER",
      "HELICOPTERS ON THE MOVE",
      "ENEMY JETS INBOUND · BRIDGE GUNS ONLINE",
      "HELICOPTERS NOW FIRE",
      "GUNBOATS FIRE FLAK"
    ],
    "levelBannerAfter": "MORE ENEMIES · FASTER FIRE",
    "sections": [
      "MISTY VALLEY",
      "PINE NARROWS",
      "HERON FLATS",
      "STONE BEND",
      "IRON FORD",
      "COLD RAPIDS",
      "HIGH TIMBER",
      "SOURCE GATE"
    ],
    "bridgeDestroyed": "BRIDGE DESTROYED +500",
    "extraJet": "EXTRA JET",
    "gameOver": "GAME OVER",
    "jetLostPrefix": "JET LOST",
    "jetLost": {
      "riverbank": "HIT THE RIVERBANK",
      "gunboat": "COLLISION · GUNBOAT",
      "heli": "COLLISION · HELICOPTER",
      "jet": "COLLISION · ENEMY JET",
      "bridge": "HIT THE BRIDGE",
      "heliFire": "HIT BY HELICOPTER FIRE",
      "flak": "HIT BY GUNBOAT FLAK",
      "bridgeGuns": "HIT BY BRIDGE GUNS",
      "fuel": "OUT OF FUEL"
    }
  }
}
